import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from './index';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? 'pl') as SupportedLanguage;

  useEffect(() => {
    document.documentElement.setAttribute('lang', current);
  }, [current]);

  return (
    <ToggleButtonGroup
      value={current}
      exclusive
      size="small"
      aria-label={t('language.label')}
      onChange={(_, value: SupportedLanguage | null) => {
        if (value && value !== current) {
          void i18n.changeLanguage(value);
        }
      }}
      sx={{
        '& .MuiToggleButton-root': {
          px: 1,
          py: 0.25,
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '0.05em',
          lineHeight: 1.2,
          minWidth: 32,
        },
      }}
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <ToggleButton key={lng} value={lng} aria-label={t(`language.${lng}`)}>
          {lng.toUpperCase()}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
